<div class="subscription" *ngIf="subscription">
  <div class="subscription__upper-row">
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.plan.amount === 100 && !subscription.metadata.multiplier">
      {{
        content?.fields?.resources | findResource: 'settings.fullSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.plan.amount === 200 && !subscription.metadata.multiplier">
      {{
        content?.fields?.resources | findResource: 'settings.doubleSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '0.25'">
      {{
        content?.fields?.resources | findResource: 'settings.quarterSubscriptionPlanName'
      }}
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '0.5'">
      {{
        content?.fields?.resources | findResource: 'settings.halfSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '1'">
      {{
        content?.fields?.resources | findResource: 'settings.fullSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '1.5'">
      {{
        content?.fields?.resources | findResource: 'settings.oneAndHalfSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '2'">
      {{
        content?.fields?.resources | findResource: 'settings.doubleSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="subscription.metadata.multiplier === '3'">
      {{
        content?.fields?.resources | findResource: 'settings.tripleSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column settings-box__field-value">
      {{
        (subscription.plan.amount * subscription.quantity) / 100
          | currency
            : (subscription.plan.currency | uppercase)
            : 'symbol-narrow'
            : '1.2-2'
            : 'fi'
      }}
      /
      {{ content?.fields?.resources | findResource: 'settings.perMonth' }}
    </div>
  </div>
  <ng-container *ngIf="subscription.status === 'active'; else needsAction">
    <div class="subscription__notice">
      {{
        content?.fields?.resources | findResource: 'settings.yourOrderNotice1'
      }}
      <span
        *ngIf="
          upcomingInvoice?.amount_due !==
          subscription.plan.amount * subscription.quantity
        "
      >
        {{
          content?.fields?.resources | findResource: 'settings.yourOrderNotice2'
        }}
        {{
          upcomingInvoice.amount_due / 100
            | currency
              : (upcomingInvoice.currency | uppercase)
              : 'symbol-narrow'
              : '1.2-2'
              : 'fi'
        }}
      </span>
      {{
        content?.fields?.resources | findResource: 'settings.yourOrderNotice3'
      }}
      {{ subscription.current_period_end * 1000 | date: 'd.M.y' }}.
    </div>
    <button
      class="subscription__cancel"
      [ngClass]="{ 'subscription__cancel--waiting': waiting }"
      [disabled]="waiting"
      (click)="cancelSubscription(subscription.id)"
    >
      {{
        content?.fields?.resources
          | findResource: 'settings.cancelOrderButtonText'
      }}
    </button>
  </ng-container>
  <ng-template #needsAction>
    <div class="subscription__notice">
      <ng-container *ngIf="subscription.status === 'past_due'">
        <span>
          {{
            content?.fields?.resources
              | findResource: 'settings.subscriptionRenewFailed'
          }}
        </span>
        <ng-container *ngIf="paymentIntent?.status === 'requires_payment_method'">
          <span>
            {{
              content?.fields?.resources
                | findResource: 'settings.pleaseUpdateYourPaymentMethod'
            }}
          </span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="subscription.status === 'incomplete'">
        <p>
          {{
            content?.fields?.resources
              | findResource: 'settings.subscriptionNotYetActive'
          }}
          <ng-container *ngIf="paymentIntent?.status === 'requires_action'">
            <a [href]="invoice?.hosted_invoice_url" target="_blank">{{
              content?.fields?.resources
                | findResource: 'settings.pleaseFinalizeYourSubscription'
            }}</a>
          </ng-container>
        </p>
      </ng-container>
    </div>
  </ng-template>
</div>
<app-price-change-consent
  [globalContent]="globalContent"
  [want]="want"
  (goAhead)="confirmCancelSubscription($event)"
></app-price-change-consent>
